"use client"

import { Text } from "@/elements"
import { GrabIcon } from "@/icons/outline/GrabIcon"
import React, { FC } from "react"

interface Props {}

export const ReorderModalItemSkeleton: FC<Props> = props => {
  return (
    <div className="flex flex-row items-center">
      <div className="px-4">
        <GrabIcon className="flex flex-shrink-0 stroke-fg-2" />
      </div>
      <div className="size-[64px] animate-pulse rounded-sm bg-bg-2 md:rounded-md" />
      <div className="pl-4">
        <div className="h-[22px] w-[200px] animate-pulse bg-bg-2" />
        <div className="mt-1 h-[18px] w-[180px] animate-pulse bg-bg-2" />
      </div>
    </div>
  )
}
